import { render } from "./ChipSelect.vue?vue&type=template&id=36bbdb7d"
import script from "./ChipSelect.vue?vue&type=script&lang=js"
export * from "./ChipSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__